import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {  Box } from "@chakra-ui/react";
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceDetail from "../../../components/maintenance/detail/detail";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as usersActions from "../../../redux/actions/users";
// Utils
import { formatDateToMadridTime, formatAccessLevels } from "../../../utils/formatters";
// Styles
import "./detail.css";

const UsersDetail = () => {
  const dispatch = useDispatch();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage);

  // Set constants
  const page = "users";
  const primaryName = !!detail && !!detail.name ? detail.name : ``;

  // Get id from url
  const { id: paramId } = useParams();
  const id = parseInt(paramId);
  // console.log('id', id);
  
  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
    // Set initial breadscrum
    const pathKey = 'detail';
    const path = `${page}/${pathKey}/${id}`;
    dispatch(mainActions.setBreadscrum(page, [{ path, pathKey, primaryValue: id, primaryName, }])); 
  }, []);

  const renderDetail = () => {
    // console.log('renderDetail > detail', detail);
    if (!detail) return null;

    const access_levels = detail.access_levels
      .split("|")
      .filter(Boolean) // Elimina elements buits
      .map(formatAccessLevels) // Aplica formatAccessLevels
      .join(", ");    

    return (
      <div className="maintenance-detail-card">
        <div className="title maintenance-detail-title">
          {detail.fullname}
        </div>
        {renderField("Id", detail.id)}
        {renderField("Email", detail.email)}
        {renderField("Niveles de acceso", access_levels)}
        <Box h={"20px"}></Box>            
        {renderField("Data de creació", formatDateToMadridTime(detail.creation_date))}
        {renderField("Usuari de creación", detail.creation_user)}
        {renderField("Data última modificació", formatDateToMadridTime(detail.last_modification_date))}
        {renderField("Usuari última modificación", detail.last_modification_user)}
      </div>
    );
  };

  const renderField = (label, value) => {
  return (
    <div className="maintenance-detail-field-parent">
      <Box className="maintenance-detail-label" w={"220px"}>
        {label}
      </Box>    
      <Box className="maintenance-detail-field">
        {value}
      </Box>         
    </div>
  );
  };

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="users-detail-content">
        <MaintenanceDetail 
          primaryValue={id}
          primaryName={primaryName}
          menuConfig={{}}
          itemNameSingular={"Usuari"}
          actions={usersActions} 
          setIsLoading={setIsLoading}
          renderDetail={renderDetail}
          setDetail={setDetail}
          page={page}
        />
      </div>
    </MainLayout>
  );
};

export default UsersDetail;
